"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _HasEmailEngagementsAPI = require("crm_ui/timeline/data/apis/HasEmailEngagementsAPI");

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _LazyKeyStore = require("crm_data/store/LazyKeyStore");

var _immutable = require("immutable");

var _makeBatch = _interopRequireDefault(require("crm_data/api/makeBatch"));

var batchFetch = (0, _makeBatch.default)(function (id) {
  var objectType = id.get('objectType');
  var subjectId = id.get('subjectId');
  return (0, _HasEmailEngagementsAPI.fetch)(objectType, subjectId);
}, 'HasEmailEngagementsStore.fetch');
(0, _LazyKeyStore.registerLazyKeyService)({
  namespace: _ActionNamespaces.HAS_EMAIL_ENGAGEMENTS,
  fetch: batchFetch
});

var _default = (0, _LazyKeyStore.defineLazyKeyStore)({
  namespace: _ActionNamespaces.HAS_EMAIL_ENGAGEMENTS,
  idIsValid: function idIsValid(key) {
    return _immutable.Map.isMap(key) && typeof key.get('subjectId') === 'string' && typeof key.get('objectType') === 'string';
  }
}).defineName('HasEmailEngagementsStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;